import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { MapPin } from "lucide-react";

// Location Modal Component
const LocationModal = ({ open, onClose, locations }) => {
  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          padding: '16px',
          maxHeight: '90vh'
        }
      }}
    >
      <DialogTitle sx={{ 
        fontSize: '1.5rem', 
        fontWeight: 600,
        color: '#1F2937',
        pb: 1,
        position: 'sticky',
        top: 0,
        backgroundColor: 'white',
        zIndex: 1
      }}>
        Available Locations
      </DialogTitle>
      <DialogContent sx={{
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
          borderRadius: '4px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '4px',
          '&:hover': {
            background: '#666',
          },
        },
      }}>
        <div className="grid gap-4 py-4">
          {locations.map((loc, index) => (
            <div 
              key={index}
              className="flex gap-3 items-center p-4 bg-gray-50 rounded-xl transition-colors hover:bg-gray-100"
            >
              <MapPin className="w-5 h-5 text-amber-600 shrink-0" />
              <div>
                <p className="font-medium text-gray-900">
                  {loc.location}
                </p>
                <p className="text-sm text-gray-500">
                  {loc.region === "all" ? "Available Nationwide" : `${loc.region} Region`}
                </p>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions sx={{
        position: 'sticky',
        bottom: 0,
        backgroundColor: 'white',
        borderTop: '1px solid #E5E7EB',
        padding: '16px 0',
        marginTop: '8px'
      }}>
        <Button 
          onClick={onClose}
          sx={{
            color: '#4B5563',
            '&:hover': { backgroundColor: '#F3F4F6' },
            textTransform: 'none',
            fontWeight: 500
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LocationModal;